import { HubBannerDto } from "@cede/types";
import { IMAGE_BREAKPOINT, ImageBreakpoint } from "@/constants/hub";
import { forgeCmsMediaUrl } from "@/utils/cms";

/**
 * Get the image URL for a specific breakpoint with fallbacks
 */
export const getBannerImageUrl = (banner: HubBannerDto, breakpoint: ImageBreakpoint): string => {
  if (breakpoint === IMAGE_BREAKPOINT.EXTRA_SMALL && banner.imageExtraSmallUrl) {
    return forgeCmsMediaUrl(banner.imageExtraSmallUrl) ?? "";
  }

  if (breakpoint === IMAGE_BREAKPOINT.SMALL && banner.imageSmallUrl) {
    return forgeCmsMediaUrl(banner.imageSmallUrl) ?? "";
  }

  if (breakpoint === IMAGE_BREAKPOINT.MEDIUM && banner.imageMediumUrl) {
    return forgeCmsMediaUrl(banner.imageMediumUrl) ?? "";
  }

  if (breakpoint === IMAGE_BREAKPOINT.LARGE && banner.imageLargeUrl) {
    return forgeCmsMediaUrl(banner.imageLargeUrl) ?? "";
  }

  // Fallback to small or empty string
  return forgeCmsMediaUrl(banner.imageSmallUrl) ?? "";
};

/**
 * Filter banners by their active date range
 */
export const filterActiveBanners = (banners: HubBannerDto[]): HubBannerDto[] => {
  const now = new Date();
  return banners.filter((banner) => {
    const startDate = new Date(banner.startDate);
    const endDate = new Date(banner.endDate);
    return now >= startDate && now <= endDate;
  });
};
